import isEmpty from "lodash/isEmpty";
import { ActionIcon } from "PFComponents/action_icon";
import { ReactNode } from "react";

import css from "./carousel.module.scss";

type CarouselProps = {
  items: React.ReactElement[];
  header: ReactNode;
  activeIndex: number;
  setActiveIndex: (index: number) => void;
  onAdd?: VoidFunction;
  onDelete?: (index: number) => void;
};

export const Carousel = ({ items, header, activeIndex, setActiveIndex, onAdd, onDelete }: CarouselProps) => {
  if (isEmpty(items)) {
    return null;
  }

  const maxIndex = items.length - 1;
  const goPrev = () => setActiveIndex(Math.max(activeIndex - 1, 0));
  const goNext = () => setActiveIndex(Math.min(activeIndex + 1, maxIndex));

  const handleAdd = () => {
    onAdd?.();
    setActiveIndex(items.length);
  };

  const handleDelete = () => {
    onDelete?.(activeIndex);
    activeIndex === items.length - 1 && setActiveIndex(activeIndex - 1);
  };

  const hasMultipleItems = items.length > 1;

  return (
    <div className={css.root}>
      {!!header && (
        <div className={css.headerContainer}>
          {hasMultipleItems && (
            <ActionIcon name="chevron-left" onClick={goPrev} disabled={activeIndex === 0} />
          )}
          <div className={css.header}>
            {header}
            {!!onAdd && <ActionIcon name="add" size="sm" onClick={handleAdd} />}
            {!!onDelete && hasMultipleItems && (
              <ActionIcon name="remove" size="sm" onClick={handleDelete} color="paletteRed1" />
            )}
          </div>
          {hasMultipleItems && (
            <ActionIcon name="chevron-right" onClick={goNext} disabled={activeIndex === maxIndex} />
          )}
        </div>
      )}
      <div className={css.content}>{items[activeIndex]}</div>
    </div>
  );
};
